<template>
    <app-layout>
        <template #header>

        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <user-list></user-list>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import UserList from '@/components/UserList'

    export default {
        components: {
            AppLayout,
            UserList
        },
    }
</script>
